(function(){
'use strict';
let viewer=null;
let items=[];
let index=0;
let opener=null;
let resume=null;
const normalize=(list)=>list.filter(v=>v&&v.src).map(v=>({src:v.src,alt:v.alt||'IRON LIGHT garment design concept',label:v.label||'GARMENT VIEW'}));
function makeViewer(){
 if(viewer)return viewer;
 viewer=document.createElement('dialog');
 viewer.className='il-zoom-dialog';
 viewer.setAttribute('aria-label','IRON LIGHT enlarged garment image viewer');
 viewer.innerHTML='<div class="il-zoom-shell"><div class="il-zoom-top"><p class="il-zoom-title" data-il-zoom-title>IRON LIGHT / GARMENT DETAILS</p><button type="button" data-il-zoom-close aria-label="Close enlarged image">×</button></div><div class="il-zoom-canvas" data-il-zoom-canvas><img class="il-zoom-image" data-il-zoom-photo alt="" draggable="false"></div><div class="il-zoom-controls"><button class="il-zoom-zoom" type="button" data-il-zoom-magnify aria-label="Toggle image zoom">ZOOM +</button><span class="il-zoom-counter" data-il-zoom-counter>01 / 04</span><div class="il-zoom-navigation"><button type="button" data-il-zoom-prev aria-label="Previous image">←</button><button type="button" data-il-zoom-next aria-label="Next image">→</button></div></div><p class="il-zoom-note">SWIPE TO EXPLORE · PRESS ESC OR × TO CLOSE · DEVELOPMENT VISUALS</p></div>';
 document.body.appendChild(viewer);
 const $=s=>viewer.querySelector(s);
 $('[data-il-zoom-close]').addEventListener('click',()=>closeViewer());
 $('[data-il-zoom-prev]').addEventListener('click',()=>move(-1));
 $('[data-il-zoom-next]').addEventListener('click',()=>move(1));
 const magnify=$('[data-il-zoom-magnify]');
 magnify.addEventListener('click',()=>{viewer.classList.toggle('is-zoomed');magnify.textContent=viewer.classList.contains('is-zoomed')?'ZOOM −':'ZOOM +'});
 const canvas=$('[data-il-zoom-canvas]');
 let start=null;
 canvas.addEventListener('pointerdown',e=>{start={x:e.clientX,y:e.clientY}});
 canvas.addEventListener('pointerup',e=>{
   if(!start)return;
   const dx=e.clientX-start.x,dy=e.clientY-start.y;
   start=null;
   if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.2)move(dx<0?1:-1);
 });
 canvas.addEventListener('pointercancel',()=>{start=null});
 viewer.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});
 viewer.addEventListener('close',()=>{
   document.body.classList.remove('il-zoom-open');
   viewer.classList.remove('is-zoomed');
   magnify.textContent='ZOOM +';
   if(resume){const fn=resume;resume=null;fn()}
   if(opener&&opener.isConnected&&typeof opener.focus==='function')opener.focus();
 });
 return viewer;
}
function render(){
 if(!viewer||!items.length)return;
 const entry=items[index];
 const img=viewer.querySelector('[data-il-zoom-photo]');
 img.src=entry.src;
 img.alt=entry.alt;
 viewer.querySelector('[data-il-zoom-title]').textContent='IRON LIGHT / '+entry.label;
 viewer.querySelector('[data-il-zoom-counter]').textContent=String(index+1).padStart(2,'0')+' / '+String(items.length).padStart(2,'0');
 viewer.querySelector('[data-il-zoom-prev]').disabled=items.length<2;
 viewer.querySelector('[data-il-zoom-next]').disabled=items.length<2;
 viewer.classList.remove('is-zoomed');
 viewer.querySelector('[data-il-zoom-magnify]').textContent='ZOOM +';
 const canvas=viewer.querySelector('[data-il-zoom-canvas]');
 canvas.scrollTop=0;
 canvas.scrollLeft=0;
}
function move(delta){
 if(items.length<2)return;
 index=(index+delta+items.length)%items.length;
 render();
}
function closeViewer(){
 if(!viewer)return;
 if(typeof viewer.close==='function'&&viewer.open)viewer.close();
 else{viewer.removeAttribute('open');viewer.dispatchEvent(new Event('close'))}
}
function openViewer(list,initial,trigger,pauseToggle){
 const clean=normalize(list);
 if(!clean.length)return;
 if(viewer?.open)closeViewer();
 const modal=makeViewer();
 items=clean;
 index=Math.min(Math.max(0,initial),clean.length-1);
 opener=trigger||document.activeElement;
 resume=null;
 if(pauseToggle){
   const active=pauseToggle.getAttribute('aria-pressed');
   const isRotor=pauseToggle.hasAttribute('data-il12-pause');
   const isPlaying=isRotor?active==='false':active==='true';
   if(isPlaying){pauseToggle.click();resume=()=>{if(pauseToggle.isConnected)pauseToggle.click()}}
 }
 render();
 document.body.classList.add('il-zoom-open');
 if(typeof modal.showModal==='function')modal.showModal();
 else modal.setAttribute('open','');
 modal.querySelector('[data-il-zoom-close]').focus();
}
function addButton(parent,selector,label,handler){
 if(!parent||parent.querySelector(selector))return;
 const button=document.createElement('button');
 button.type='button';
 button.className='il-zoom-trigger '+selector.slice(1);
 button.textContent=label;
 button.setAttribute('aria-label','Expand the garment image to full screen');
 button.addEventListener('click',e=>{e.stopPropagation();handler(button)});
 parent.appendChild(button);
}
function setup(){
 document.querySelectorAll('#il9 .il-white-feature').forEach(feature=>{
   const frames=[...feature.querySelectorAll('[data-il-white-frame] img')];
   if(frames.length!==4)return;
   frames.forEach((img,i)=>{
     const tile=img.closest('[data-il-white-frame]');
     if(tile.dataset.ilWhiteLightboxReady)return;
     tile.dataset.ilWhiteLightboxReady='1';
     addButton(tile,'.il-zoom-trigger--white','EXPAND ↗',button=>{
       openViewer(frames.map((picture,j)=>({src:picture.currentSrc||picture.src,alt:picture.alt,label:['FRONT / WHITE','THREE-QUARTER / WHITE','RIGHT SIDE / WHITE','BACK / WHITE'][j]})),i,button,null);
     });
   });
 });

 document.querySelectorAll('#il9 [data-il12-rotor]').forEach(rotor=>{
   if(rotor.dataset.ilZoomSetup)return;
   rotor.dataset.ilZoomSetup='1';
   const position=rotor.querySelector('.il12-rotor-space');
   const slides=[...rotor.querySelectorAll('[data-il12-view]')];
   if(!position||!slides.length)return;
   const open=trigger=>{
     const current=slides.findIndex(b=>b.getAttribute('aria-pressed')==='true');
     const frames=slides.map((b,i)=>{
       const img=b.querySelector('img');
       return {src:img?.currentSrc||img?.src,alt:img?.alt,label:['FRONT','THREE-QUARTER','SIDE','BACK'][i]||'GARMENT VIEW'};
     });
     openViewer(frames,Math.max(0,current),trigger,rotor.querySelector('[data-il12-pause]'));
   };
   addButton(position,'.il-zoom-trigger--rotor','EXPAND ↗',open);
   rotor.addEventListener('click',e=>{
     const hit=e.target.closest('[data-il12-view]');
     if(hit&&hit.getAttribute('aria-pressed')==='true'){
       e.stopImmediatePropagation();
       e.preventDefault();
       open(hit);
     }
   },true);
 });
 document.querySelectorAll('[data-il12-container]').forEach(root=>{
   if(root.dataset.ilZoomSetup)return;
   root.dataset.ilZoomSetup='1';
   const stage=root.querySelector('[data-il12-stage]');
   const host=root.querySelector('[data-il12-assets]');
   if(!stage||!host)return;
   let assets;
   try{assets=JSON.parse(host.getAttribute('data-il12-assets')||'{}')}catch{return}
   const open=trigger=>{
     const white=stage.dataset.il12Colour==='white';
     const names=white?['FRONT / WHITE','THREE-QUARTER / WHITE','RIGHT SIDE / WHITE','BACK / WHITE']:['THREE-QUARTER','FRONT','SIDE','BACK'];
     const urls=white?[assets.white_front,assets.white_quarter,assets.white_side,assets.white_back]:[assets.profile,assets.front,assets.side,assets.back];
     const n=Number(root.querySelector('[data-il12-count]')?.textContent||1)-1;
     const frames=urls.map((src,i)=>({src,alt:'IRON LIGHT '+(white?'white':'black')+' garment design-stage concept, '+names[i]+' view; not a physically validated sample',label:names[i]}));
     openViewer(frames,Number.isFinite(n)?n:0,trigger,root.querySelector('[data-il12-auto]'));
   };
   addButton(stage,'.il-zoom-trigger--stage','EXPAND ↗',open);
   let moved=false,startX=null,startY=null;
   stage.addEventListener('pointerdown',e=>{moved=false;startX=e.clientX;startY=e.clientY});
   stage.addEventListener('pointerup',e=>{if(startX!==null){moved=Math.abs(e.clientX-startX)>25||Math.abs(e.clientY-startY)>25}startX=null;startY=null});
   stage.addEventListener('click',e=>{
     if(e.target.closest('.il-zoom-trigger'))return;
     if(moved){moved=false;return}
     open(stage);
   });
   stage.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();open(stage)}});
 });
 document.querySelectorAll('#ilp .ilp-image-tile').forEach(tile=>{
   if(tile.dataset.ilZoomSetup)return;
   const img=tile.querySelector('img');
   if(!img)return;
   tile.dataset.ilZoomSetup='1';
   addButton(tile,'.il-zoom-trigger--detail','EXPAND ↗',button=>{
     const grid=tile.closest('.ilp-grid4')||tile.parentElement;
     const photos=[...grid.querySelectorAll('.ilp-image-tile img')];
     const list=photos.map(photo=>({src:photo.currentSrc||photo.src,alt:photo.alt,label:photo.alt||'GARMENT DETAIL'}));
     openViewer(list,Math.max(0,photos.indexOf(img)),button,null);
   });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});
else setup();
document.addEventListener('shopify:section:load',setup);
})();